export default "__VITE_ASSET__9v8C2wZH__"